import device from "./device.vue";
export default device;